import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './styles/index.css';
import { initAnalytics } from '@/lib/analytics';
import { initIntercom } from '@/lib/intercom';
import { initSessionReplay } from '@/lib/sessionReplay';
import { initTelemetry } from '@/lib/telemetry';

initAnalytics();
initIntercom();
initSessionReplay();
initTelemetry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>,
);
